/**
 * "Install prompt" (docs/06-roadmap.md P4-02). Mounted once at the app root (`AppProviders`), not
 * inside `AppShell` — installability isn't tied to being signed in, so this should be offerable
 * from `/signin` too, unlike `ToastViewport`'s narrower, authenticated-app-only scope.
 */
import { usePwaInstall } from '@/features/pwa/install-context';

export function InstallPromptBanner() {
  const install = usePwaInstall();
  if (!install?.canInstall) return null;
  const { promptInstall, dismiss } = install;

  return (
    <div
      role="region"
      aria-label="Install FinBob"
      className="glass fixed inset-x-4 bottom-20 z-20 flex items-center justify-between gap-3 rounded-[var(--radius)] p-3 md:inset-x-auto md:right-4 md:bottom-4 md:w-80"
    >
      <p className="text-sm text-[var(--text)]">
        Install FinBob for quick access in its own window.
      </p>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={() => void promptInstall()}
          className="rounded-[var(--radius)] bg-[var(--accent)] px-3 py-1.5 text-sm font-medium text-[var(--fill-text)]"
        >
          Install
        </button>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss install prompt"
          className="rounded-[var(--radius)] px-2 py-1.5 text-sm text-[var(--text-muted)] hover:text-[var(--text)]"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
